import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
class NzFlexDirective {
  constructor() {
    this.nzVertical = false;
    this.nzJustify = 'normal';
    this.nzAlign = 'normal';
    this.nzGap = 0;
    this.nzWrap = 'nowrap';
    this.nzFlex = 'unset';
  }
  get gap() {
    switch (this.nzGap) {
      case 'small':
        return '8px';
      case 'middle':
        return '16px';
      case 'large':
        return '24px';
      default:
        if (typeof this.nzGap === 'number') {
          return `${this.nzGap}px`;
        }
        return this.nzGap;
    }
  }
  static {
    this.ɵfac = function NzFlexDirective_Factory(t) {
      return new (t || NzFlexDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzFlexDirective,
      selectors: [["", "nz-flex", ""], ["nz-flex"]],
      hostAttrs: [1, "ant-flex"],
      hostVars: 60,
      hostBindings: function NzFlexDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("gap", ctx.gap)("flex", ctx.nzFlex);
          i0.ɵɵclassProp("ant-flex-vertical", ctx.nzVertical)("ant-flex-justify-flex-start", ctx.nzJustify === "flex-start")("ant-flex-justify-center", ctx.nzJustify === "center")("ant-flex-justify-flex-end", ctx.nzJustify === "flex-end")("ant-flex-justify-space-between", ctx.nzJustify === "space-between")("ant-flex-justify-space-around", ctx.nzJustify === "space-around")("ant-flex-justify-space-evenly", ctx.nzJustify === "space-evenly")("ant-flex-justify-start", ctx.nzJustify === "start")("ant-flex-justify-end", ctx.nzJustify === "end")("ant-flex-justify-right", ctx.nzJustify === "right")("ant-flex-justify-left", ctx.nzJustify === "left")("ant-flex-justify-stretch", ctx.nzJustify === "stretch")("ant-flex-justify-normal", ctx.nzJustify === "normal")("ant-flex-align-flex-start", ctx.nzAlign === "flex-start")("ant-flex-align-center", ctx.nzAlign === "center")("ant-flex-align-flex-end", ctx.nzAlign === "flex-end")("ant-flex-align-space-between", ctx.nzAlign === "space-between")("ant-flex-align-space-around", ctx.nzAlign === "space-around")("ant-flex-align-space-evenly", ctx.nzAlign === "space-evenly")("ant-flex-align-start", ctx.nzAlign === "start")("ant-flex-align-end", ctx.nzAlign === "end")("ant-flex-align-right", ctx.nzAlign === "right")("ant-flex-align-left", ctx.nzAlign === "left")("ant-flex-align-stretch", ctx.nzAlign === "stretch")("ant-flex-align-normal", ctx.nzAlign === "normal")("ant-flex-wrap-wrap", ctx.nzWrap === "wrap")("ant-flex-wrap-wrap-reverse", ctx.nzWrap === "wrap-reverse")("ant-flex-wrap-nowrap", ctx.nzWrap === "nowrap");
        }
      },
      inputs: {
        nzVertical: "nzVertical",
        nzJustify: "nzJustify",
        nzAlign: "nzAlign",
        nzGap: "nzGap",
        nzWrap: "nzWrap",
        nzFlex: "nzFlex"
      },
      exportAs: ["nzFlex"],
      standalone: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NzFlexDirective, [{
    type: Directive,
    args: [{
      selector: '[nz-flex],nz-flex',
      exportAs: 'nzFlex',
      standalone: true,
      host: {
        class: 'ant-flex',
        '[class.ant-flex-vertical]': `nzVertical`,
        '[class.ant-flex-justify-flex-start]': `nzJustify === 'flex-start'`,
        '[class.ant-flex-justify-center]': `nzJustify === 'center'`,
        '[class.ant-flex-justify-flex-end]': `nzJustify === 'flex-end'`,
        '[class.ant-flex-justify-space-between]': `nzJustify === 'space-between'`,
        '[class.ant-flex-justify-space-around]': `nzJustify === 'space-around'`,
        '[class.ant-flex-justify-space-evenly]': `nzJustify === 'space-evenly'`,
        '[class.ant-flex-justify-start]': `nzJustify === 'start'`,
        '[class.ant-flex-justify-end]': `nzJustify === 'end'`,
        '[class.ant-flex-justify-right]': `nzJustify === 'right'`,
        '[class.ant-flex-justify-left]': `nzJustify === 'left'`,
        '[class.ant-flex-justify-stretch]': `nzJustify === 'stretch'`,
        '[class.ant-flex-justify-normal]': `nzJustify === 'normal'`,
        '[class.ant-flex-align-flex-start]': `nzAlign === 'flex-start'`,
        '[class.ant-flex-align-center]': `nzAlign === 'center'`,
        '[class.ant-flex-align-flex-end]': `nzAlign === 'flex-end'`,
        '[class.ant-flex-align-space-between]': `nzAlign === 'space-between'`,
        '[class.ant-flex-align-space-around]': `nzAlign === 'space-around'`,
        '[class.ant-flex-align-space-evenly]': `nzAlign === 'space-evenly'`,
        '[class.ant-flex-align-start]': `nzAlign === 'start'`,
        '[class.ant-flex-align-end]': `nzAlign === 'end'`,
        '[class.ant-flex-align-right]': `nzAlign === 'right'`,
        '[class.ant-flex-align-left]': `nzAlign === 'left'`,
        '[class.ant-flex-align-stretch]': `nzAlign === 'stretch'`,
        '[class.ant-flex-align-normal]': `nzAlign === 'normal'`,
        '[class.ant-flex-wrap-wrap]': `nzWrap === 'wrap'`,
        '[class.ant-flex-wrap-wrap-reverse]': `nzWrap === 'wrap-reverse'`,
        '[class.ant-flex-wrap-nowrap]': `nzWrap === 'nowrap'`,
        '[style.gap]': `gap`,
        '[style.flex]': `nzFlex`
      }
    }]
  }], null, {
    nzVertical: [{
      type: Input
    }],
    nzJustify: [{
      type: Input
    }],
    nzAlign: [{
      type: Input
    }],
    nzGap: [{
      type: Input
    }],
    nzWrap: [{
      type: Input
    }],
    nzFlex: [{
      type: Input
    }]
  });
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
class NzFlexModule {
  static {
    this.ɵfac = function NzFlexModule_Factory(t) {
      return new (t || NzFlexModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NzFlexModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NzFlexModule, [{
    type: NgModule,
    args: [{
      imports: [NzFlexDirective],
      exports: [NzFlexDirective]
    }]
  }], null, null);
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzFlexDirective, NzFlexModule };
